"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._Pagination = exports._Media = exports._Icon = exports._ExternalLink = exports._Date = exports._Collection = void 0;
var _icon = _interopRequireDefault(require("wever-core/dist/components/common/icon"));
var _date = _interopRequireDefault(require("wever-core/dist/components/common/date"));
var _collection = _interopRequireDefault(require("wever-core/dist/components/common/collection"));
var _pagination = _interopRequireDefault(require("wever-core/dist/components/common/pagination"));
var _externalLink = _interopRequireDefault(require("wever-core/dist/components/common/external-link"));
var _media = _interopRequireDefault(require("wever-core/dist/components/common/media"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const _Icon = exports._Icon = _icon.default;
const _Date = exports._Date = _date.default;
const _Collection = exports._Collection = _collection.default;
const _Pagination = exports._Pagination = _pagination.default;
const _ExternalLink = exports._ExternalLink = _externalLink.default;
const _Media = exports._Media = _media.default;
const DefaultObject = {
  _Icon,
  _Date,
  _Collection,
  _Pagination,
  _ExternalLink,
  _Media
};
var _default = exports.default = DefaultObject;